import axios from 'axios'
import type { FieldValues, Path, UseFormSetError } from 'react-hook-form'
import { getApiErrorCode } from '../../api/apiError'

/**
 * Sunucu hatası → RHF alan hatası eşlemesi (020). Domaine özel iş kodu (ör. DUPLICATE_CODE) veya
 * 400 gövdesindeki `field` ilgili form alanına `setError` ile yazılır (019 merkezi hata yönetimiyle
 * uyumlu: eşlenen kodlar ekranda alan hatası olarak gösterilir, `meta.handledCodes` merkezî toast'ı
 * susturur → çift bildirim yok). Eşleşme yoksa `false` döner; çağıran hatayı merkezî bildirime bırakır.
 */
export interface ServerFieldRule {
  field: string
  /** i18n anahtarı veya düz metin (resolveFieldError ile gösterilir). */
  message: string
}

function bodyField(error: unknown): string | null {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as { field?: string } | undefined
    return data?.field ?? null
  }
  return null
}

export function applyServerFieldError<TFieldValues extends FieldValues>(
  error: unknown,
  setError: UseFormSetError<TFieldValues>,
  codeMap?: Record<string, ServerFieldRule>,
): boolean {
  // 1) Domaine özel iş kodu (admin diyalogları: DUPLICATE_CODE/DUPLICATE_NAME …).
  const code = getApiErrorCode(error)
  if (code && codeMap?.[code]) {
    const rule = codeMap[code]
    setError(rule.field as Path<TFieldValues>, { type: 'server', message: rule.message })
    return true
  }
  // 2) 400 gövdesindeki alan adı (ör. TicketRequestNewPage).
  const field = bodyField(error)
  if (field) {
    setError(field as Path<TFieldValues>, { type: 'server', message: 'validation.invalid' })
    return true
  }
  // 3) Alan-bazlı değil → merkezî bildirime bırak (019).
  return false
}
